import {FC} from "react";
import {css, cx} from "@pandacss/css";

const modules = import.meta.glob(`./icons/**/*.svg`, {eager: true, import: 'default', query: '?raw'});

interface IconProps {
    size?: number;
    alt?: string;
    className?: string
    onClick?: () => void
}

export type Icon = FC<IconProps>;

const matchTextSize = css({
    height: "var(--line-height)",
    width: "var(--line-height)",
    display: "inline-block",
    flexShrink: 0,
})

const matchTextColor = css({
    color: "var(--color-text)",
})

const cursorPointer = css({
    cursor: "pointer",
})

const createIcon = (name: string, filename: string): Icon => {
    const filepath = `./icons/${filename}.svg`
    const svgContent = modules[filepath] as string
    if (!svgContent) {
        console.log(filepath)
    }

    const icon: Icon = ({size, alt, className, onClick}) => {
        const siteAttributes = size ? `width="${size}" height="${size}"` : '';
        let modifiedSvgContent = svgContent.replace(/width="(\d+)" height="(\d+)"/, siteAttributes);
        if (!modifiedSvgContent.includes(siteAttributes)) {
            // Put it directly after `<svg `
            modifiedSvgContent = svgContent.replace(/<svg /, `<svg ${siteAttributes} `);
        }

        return (
            <span
                className={cx(className, size ? undefined : matchTextSize, matchTextColor, onClick ? cursorPointer : undefined)}
                style={{width: size, height: size}}
                onClick={onClick}
                dangerouslySetInnerHTML={{__html: modifiedSvgContent}}
                role="img"
                aria-label={alt || ''}
            />
        );
    };
    icon.displayName = name;

    return icon;
}

export const PlaceholderIcon = createIcon('PlaceholderIcon', 'placeholder');
export const InfoCircleErrorIcon = createIcon('InfoCircleErrorIcon', 'info-circle-error');
export const ArrowDownIcon = createIcon('ArrowDownIcon', 'arrow-down');
export const ArrowLeftIcon = createIcon('ArrowLeftIcon', 'arrow-left');
export const ArrowRightIcon = createIcon('ArrowRightIcon', 'arrow-right');
export const CloseCircleIcon = createIcon('CloseCircleIcon', 'close-circle');
export const MenuIcon = createIcon('MenuIcon', 'menu');
export const CopySuccessIcon = createIcon('CopySuccessIcon', 'copy-success');
export const SendIcon = createIcon('SendIcon', 'send-2');
export const CameraIcon = createIcon('CameraIcon', 'camera');
export const MicrophoneIcon = createIcon('MicrophoneIcon', 'microphone');
export const Microphone2Icon = createIcon('Microphone2Icon', 'microphone-2');
export const WifiSquareIcon = createIcon('WifiSquareIcon', 'wifi-square');
export const AlarmIcon = createIcon('AlarmIcon', 'alarm');
export const ElectricityIcon = createIcon('ElectricityIcon', 'electricity');
export const HumidityLowIcon = createIcon('HumidityLowIcon', 'humidity-low');
export const LocationIcon = createIcon('LocationIcon', 'location');
export const WarningIcon = createIcon('WarningIcon', 'warning-2');
export const SubtitleIcon = createIcon('SubtitleIcon', 'subtitle');
export const AddCirclePrimaryIcon = createIcon('AddCirclePrimaryIcon', 'add-circle-primary');
export const SettingsIcon = createIcon('SettingsIcon', 'settings');
export const ArchiveTickIcon = createIcon('ArchiveTickIcon', 'archive-tick');
export const ExportIcon = createIcon('ExportIcon', 'export-arrow');
export const CheckmarkIcon = createIcon('CheckmarkIcon', 'checkmark');

export default createIcon;